import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { BookOpen, Play, Sparkles } from "lucide-react";

const STEPS = [
  "Create a network for your business",
  "Invite trusted brokers to join your network",
  "Post freight to your private network first",
  "Receive private bids and quotes",
  "Award and dispatch through delivery",
];

interface GettingStartedCardProps {
  onOpenHelp: () => void;
  demoUrl: string;
}

export function GettingStartedCard({ onOpenHelp, demoUrl }: GettingStartedCardProps) {
  return (
    <Card className="p-5 h-full">
      <div className="flex items-center gap-2 mb-3">
        <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-brand-teal/10">
          <Sparkles className="h-4 w-4 text-brand-teal" />
        </div>
        <h2 className="text-sm font-bold uppercase tracking-wider">Getting Started</h2>
      </div>
      <ol className="space-y-2.5">
        {STEPS.map((step, i) => (
          <li key={i} className="flex items-start gap-3">
            <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-brand-teal text-white text-[11px] font-bold">
              {i + 1}
            </span>
            <span className="text-sm text-foreground leading-6">{step}</span>
          </li>
        ))}
      </ol>
      <div className="mt-4 pt-4 border-t border-border flex flex-wrap items-center gap-2">
        <Button variant="link" size="sm" onClick={onOpenHelp} className="h-8 px-0 text-brand-teal gap-1.5">
          <BookOpen className="h-3.5 w-3.5" />
          View help guide
        </Button>
        <span className="text-muted-foreground/40 hidden sm:inline">·</span>
        <a
          href={demoUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1.5 h-8 px-3 rounded-md border border-border bg-background hover:bg-muted/60 transition-colors text-xs font-semibold text-foreground"
        >
          <Play className="h-3.5 w-3.5 text-brand-teal" fill="currentColor" />
          Watch Demo
        </a>
      </div>
    </Card>
  );
}

export default GettingStartedCard;
